import { ChevronUp } from "lucide-react";
import { useState } from "react";

const TaskCard = ({
  masterTasks,
  selectedTaskIds,
  setSelectedTaskIds,
  getCheckState,
  toggleTask,
}) => {
  const [openMilestone, setOpenMilestone] = useState(null);

  const toggleMilestone = (id) => {
    setOpenMilestone(openMilestone === id ? null : id);
  };

  return (
    <ul className="rounded max-h-[60vh] overflow-y-auto space-y-3">
      {masterTasks.map((task) => {
        const { isChecked, isIndeterminate } = getCheckState(task);
        return (
          <li key={task.id}>
            <div className="flex items-center border border-gray-300 rounded-md px-3 py-2 gap-3">
              {/* Left: Chevron */}
              <div className="w-6 flex-shrink-0 flex justify-center">
                <ChevronUp
                  className={`${
                    openMilestone === task.id ? "rotate-180" : "rotate-90"
                  } transform transition-transform duration-300 cursor-pointer`}
                  onClick={() => toggleMilestone(task.id)}
                />
              </div>

              {/* Middle: Text */}
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-md font-semibold truncate">
                  {task.title}
                </h4>
                <p className="text-xs md:text-sm text-gray-600 truncate">
                  {task.description}
                </p>
              </div>

              {/* Right: Weight + Checkbox */}
              <div className="w-24 flex-shrink-0 flex items-center justify-end gap-2">
                <span className="text-sm">{task.weight}</span>
                <input
                  type="checkbox"
                  checked={isChecked}
                  ref={(el) => {
                    if (el) el.indeterminate = isIndeterminate;
                  }}
                  onChange={() => toggleTask(task)}
                  className="rounded border-gray-300 text-blue-500 focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {openMilestone === task.id && (
              <div className="pl-3 mt-3 border-l">
                {task?.sub_tasks?.length > 0 ? (
                  <TaskCard
                    masterTasks={task?.sub_tasks}
                    selectedTaskIds={selectedTaskIds}
                    setSelectedTaskIds={setSelectedTaskIds}
                    getCheckState={getCheckState}
                    toggleTask={toggleTask}
                  />
                ) : (
                  <p className="text-sm text-gray-400 italic">No sub-tasks</p>
                )}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default TaskCard;
